import { environment } from '../environments/environment';
import { AfterViewInit, Component, HostListener, OnDestroy, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { LoaderService } from './shared/service/loader.service';
import { AuthenticationService, RELOGIN_STATE, ReloginStateService } from '@datev/ngx-dcal';
import { BannerService } from './shared/service/banner.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { PreviewDocumentService } from './shared/service/preview-document.service';

@Component({
  selector: 'frageboegen-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild('appContainer') appContainer;
  @ViewChild('appHeader') appHeaderElement;
  @ViewChild('uebersichtHeader') uebersichtHeaderElement;
  @ViewChild('messageBanners') messageBannersElement;

  isPublished = false;
  fseLink = 'https://apps.datev.de/help-center/products/datev-frageboegen-zur-steuerlichen-erfassung';
  isLoggedIn = false;
  showGeneralBanner$;
  isDAPHeaderSettings = false;

  private readonly bannerSubscription: Subscription;

  // Do not remove ViewContainerRef in order to prevent Error:
  // ViewContainerRef must be injected in app root module in order to make global Datev notifications work
  constructor(private readonly viewContainerRef: ViewContainerRef,
    public readonly loadingService: LoaderService,
    private readonly router: Router,
    private readonly reLoginStateService: ReloginStateService,
    public readonly bannerService: BannerService,
    private readonly authenticationService: AuthenticationService,
    private previewDocumentService: PreviewDocumentService) {


    this.isDAPHeaderSettings = localStorage['dap'] === 'true';

    this.isPublished = environment.isPublished;
    this.authenticationService.isLoggedIn.subscribe((isLoggedIn: boolean) => {
      this.isLoggedIn = isLoggedIn;
      if (isLoggedIn) {
        setTimeout(() => {
          this.initAppHeight();
        });
      }
      this.reLoginStateService.currentState.subscribe((reloginState: RELOGIN_STATE) => {
        this.loadingService.isLoading = { isLoading: false };
        if (reloginState === RELOGIN_STATE.CHECK_PENDING || reloginState === RELOGIN_STATE.RELOGIN_PENDING) {
          this.loadingService.isLoading = { isLoading: true };
        }
      });
    });
    this.showGeneralBanner$ = bannerService.showGeneralBanner;
    bannerService.setGeneralBannerVisibility(false);

 
    // This event is usually triggered when the PDF viewer is closed.
    this.previewDocumentService.onClosePdfViewer.subscribe(() => {

      // Starts a polling mechanism
      const pollingInterval = setInterval(() => {
        let frageboegenAttachments = document.querySelector('frageboegen-attachments') as HTMLElement;

        // Checks if if it is visible in the DOM
        if (frageboegenAttachments && frageboegenAttachments.offsetHeight > 0) {
          clearInterval(pollingInterval);
          this.initAppHeight();
        }
      }, 100);  // Checks every 100ms
    });
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.initAppHeight();
  }

  public ngOnInit(): void {
    const doc = document.documentElement;
    doc.style.setProperty('--banners-height', '0px');
    doc.style.setProperty('--uebersicht-header-height', '0px');
    doc.style.setProperty('--uebersicht-footer-height', '0px');
    doc.style.setProperty('--table-header-height', '0px');
    doc.style.setProperty('--removed-banners-height', '0px');
  }

  public ngAfterViewInit(): void {
    if (this.isLoggedIn) {
      this.initAppHeight();
    }
  }

  public ngOnDestroy(): void {
    this.bannerSubscription.unsubscribe();
  }

  public closeBanner(): void {
    const bannerHeight = this.messageBannersElement.nativeElement.offsetHeight;
    document.documentElement.style.setProperty('--removed-banners-height', `${bannerHeight}px`);
    this.bannerService.setGeneralBannerVisibility(false);
  }

  private initAppHeight(): void {
    const doc = document.documentElement;
    
    const windowHeight = window.innerHeight;
    doc.style.setProperty('--app-height', `${windowHeight}px`);

    const windowWidth = window.innerWidth;
    doc.style.setProperty('--app-width', `${windowWidth}px`);

    const appHeaderHeight = this.appHeaderElement.nativeElement.offsetHeight;
    doc.style.setProperty('--app-header-height', `${appHeaderHeight}px`);

  }

}
